import $ from "jquery";

$(function() {
    $(".auflistungschulungen").on("click", ".btnshowform", function() {
        const $btn = $(this);
        const $form = $btn.closest(".accordion-item").find(".schulunganmeldung");
        $form.slideDown(200);
    });
});
